export const cn = {
    NavBar: {
        air: '首页',
        tools: '工具',
        project: '技术预研报告',
        whiteboard: '技术方案探索',
        fmea: '设计失效分析',
        explore: '行业技术报告',
        newsletter: '技术监控',
        topics: '技术库',
        mySubscription: '我的订阅',
        history: '最近的工作',
        deleteTitle: '确认删除记录',
        deleteContent: '您确定要永久删除此记录吗？删除后将无法恢复此数据。',
        cancel: '取消',
        confirm: '删除',
        deleteSuccess: '您的记录已成功删除',
        open: '展开侧栏',
        close: '关闭侧栏',
        incognito: '已开启无痕模式',
        incognitoTip: '无痕模式下，您的搜索记录将不会被保存',
        deleteAllTitle: '确认删除所有缓存及已有记录',
        deleteAllContent: '您确定要删除所有数据吗？删除后将无法恢复, 您分享的内容也将立即失效。',
    },
    HistoryType: {
        SEEK_SEARCH: '技术信息问答​',
        TECH_MIND: '技术方案探索',
        TECH_RESEARCH: '技术预研报告',
        TECH_FMEA: '设计失效分析',
        IDEA_EXPLORATION: '技术预研报告',
    },
}

export const en = {
    NavBar: {
        air: 'Homepage',
        tools: 'Tools',
        project: 'TechResearch',
        whiteboard: 'TechMind',
        fmea: 'TechRisk D-FMEA',
        explore: 'TechReports',
        newsletter: 'Tech Monitor',
        topics: 'Library',
        mySubscription: 'My Subscription',
        history: 'Recent Records',
        deleteTitle: 'Confirm Record Deletion',
        deleteContent: 'Are you sure you want to permanently delete this record? This action cannot be undone.',
        cancel: 'Cancel',
        confirm: 'Delete',
        deleteSuccess: 'Your record has been deleted successfully',
        open: 'Expand Sidebar',
        close: 'Collapse Sidebar',
        incognito: 'Incognito Mode',
        incognitoTip: 'In Incognito Mode, your search history will not be saved.',
        deleteAllTitle: 'Confirm Deletion of All Cache and Existing Records',
        deleteAllContent: 'Are you sure you want to delete all data? This action cannot be undone, and any content you have shared will immediately become inaccessible.',
    },
    HistoryType: {
        SEEK_SEARCH: 'TechSeek',
        TECH_MIND: 'TechMind',
        TECH_RESEARCH: 'TechResearch',
        TECH_FMEA: 'TechRisk D-FMEA',
        IDEA_EXPLORATION: 'Techmind Explorer',
    },
}

export const jp = {
    NavBar: {
        air: 'ホーム',
        tools: 'ツール',
        project: '技術予備調査レポート',
        whiteboard: '技術ソリューション探索',
        fmea: '設計FMEA',
        explore: '技術報告',
        newsletter: '技術モニター',
        topics: '技術ライブラリ',
        mySubscription: '私の購読',
        history: '最近の記録',
        deleteTitle: '記録削除の確認',
        deleteContent: 'この記録を完全に削除してもよろしいですか？削除後、このデータは復元できません。',
        cancel: 'キャンセル',
        confirm: '削除',
        deleteSuccess: '記録が削除されました',
        open: 'サイドバーを展開',
        close: 'サイドバーを閉じる',
        incognito: 'シークレット有効',
        incognitoTip: 'シークレットモードでは、検索履歴は保存されません。',
        deleteAllTitle: 'すべてのキャッシュと既存の記録を削除しますか？',
        deleteAllContent: 'すべてのデータを削除してもよろしいですか？この操作は元に戻すことができません。共有したコンテンツもすぐにアクセスできなくなります。',
    },
    HistoryType: {
        SEEK_SEARCH: '技術情報問答',
        TECH_MIND: '技術ソリューション探索',
        TECH_RESEARCH: '技術予備調査レポート',
        TECH_FMEA: '設計FMEA',
        IDEA_EXPLORATION: '技術ソリューション探索',
    },
}

export const tw = {
    NavBar: {
        air: '首頁',
        tools: '工具',
        project: '技術預研報告',
        whiteboard: '技術方案探索',
        fmea: '設計失效分析',
        explore: '行業技術報告',
        newsletter: '技術監控',
        topics: '技術库',
        mySubscription: '我的訂閱',
        history: '最近的記錄',
        deleteTitle: '確認刪除記錄',
        deleteContent: '您確定要永久刪除此記錄嗎？刪除後將無法恢復此數據。',
        cancel: '取消',
        confirm: '刪除',
        deleteSuccess: '您的記錄已成功刪除',
        open: '展開側欄',
        close: '關閉側欄',
        incognito: '已開啟無痕模式',
        incognitoTip: '無痕模式下，您的搜索記錄將不會被保存',
        deleteAllTitle: '確認刪除所有緩存及已有記錄',
        deleteAllContent: '您確定要刪除所有數據嗎？刪除後將無法恢復, 您分享的內容也將立即失效。',
    },
    HistoryType: {
        SEEK_SEARCH: '技術資訊問答',
        TECH_MIND: '技術方案探索',
        TECH_RESEARCH: '技術預研報告',
        TECH_FMEA: '設計失效分析',
        IDEA_EXPLORATION: '技術方案探索',
    },
}
